// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__27FPS","buttons":"PendingPaymentAlert_buttons__TIXJx"};